var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10 col-md-8 col-12 main"},[_c('YouTubeEmbed',{attrs:{"videoId":"N30UI7KLP-I","lazy":true,"useApi":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }